export default __webpack_public_path__ + "img/field-pipeline.e2ae67.svg";